/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeposit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h16v14h2v6H2v-6h2zm0 16v2h16v-2zm14-2V8.393a5.018 5.018 0 0 1-2.208-1.067c-.875-.74-1.526-1.833-1.727-3.326h-4.13c-.2 1.493-.853 2.586-1.727 3.326A5.018 5.018 0 0 1 6 8.393V16zm0-9.68V4h-1.91c.173.882.57 1.44.993 1.8.284.239.602.408.917.52zM7.91 4H6v2.32c.315-.112.633-.281.917-.52.424-.36.82-.918.993-1.8zM8 11a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDeposit as Deposit };
